import { Injectable, makeStateKey, TransferState } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TransferStateService {
    constructor(private readonly transferState: TransferState) {}

    set<T>(key: string, value: T): void {
        const stateKey = makeStateKey<T>(key);
        this.transferState.set(stateKey, value);
    }

    get<T>(key: string): T | null {
        const stateKey = makeStateKey<T>(key);
        return this.transferState.get(stateKey, null);
    }

    hasKey(key: string): boolean {
        const stateKey = makeStateKey(key);
        return this.transferState.hasKey(stateKey);
    }

    removeKey(key: string): void {
        const stateKey = makeStateKey(key);
        this.transferState.remove(stateKey);
    }
}
